import { render, staticRenderFns } from "./tongzhiMsg.vue?vue&type=template&id=37901d18&scoped=true"
import script from "./tongzhiMsg.vue?vue&type=script&lang=js"
export * from "./tongzhiMsg.vue?vue&type=script&lang=js"
import style0 from "./tongzhiMsg.vue?vue&type=style&index=0&id=37901d18&prod&lang=scss"
import style1 from "./tongzhiMsg.vue?vue&type=style&index=1&id=37901d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37901d18",
  null
  
)

export default component.exports